import { render, staticRenderFns } from "./ElementCratorTable.vue?vue&type=template&id=d220d07c"
import script from "./ElementCratorTable.vue?vue&type=script&lang=js"
export * from "./ElementCratorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports